/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { api } from "../lib/api";
import { IWorkspace } from "@/interfaces/Workspace.interface";

/**
 * Registers a user
 *
 * @param userData - user data to be sent to the server
 * @returns A Promise that resolves to a success message.
 */
// export const registerUser = (userData: IUserRegistrationData): Promise<any> => {
//   return api.post(`/users`, { ...userData });
// };

/**
 * User Info
 *
 * @param userId - userId
 * @returns A Promise that resolves to a success message.
 */
export const getWorkspacesList = (): Promise<IWorkspace[]> => {
  return api.get(`/workspaces`, { withAuth: true });
};
